import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import Button from '../../../atoms/buttons/Button';
import Paragraph from '../../../atoms/paragraphs/Paragraph';
import { buildPath } from '../../../organisms/containers/util/pathHelper';
import { ReactComponent as IxLoading } from '../../../../assets/imgs/ix-loading.svg';
import Image from '../../../atoms/images/Image';
import MbReferenceModal from '../../../organisms/modals/checkout/MbReferenceModal';

const CheckoutPagePaymentResponse = ({ intl, ...props }) => {
  const { checkoutInfo, isReferencePayment, isFreePlan } = props;
  const [paymentReference, setPaymentReference] = useState({
    entity: '',
    reference: '',
    amount: '',
  });
  const [state, setState] = useState('waiting');

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    const fetchPaymentResponse = async () => {
      if (isFreePlan === 'true') {
        await sleep(2000);
        setState('success');
      }
    };

    fetchPaymentResponse();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (checkoutInfo !== undefined) {
      if (isReferencePayment !== undefined && isReferencePayment !== false) {
        setPaymentReference({
          entity: checkoutInfo.entity,
          reference: checkoutInfo.reference,
          amount: checkoutInfo.amount,
        });
        setTimeout(() => {
          setState('reference');
        }, 2000);
      } else {
        switch (checkoutInfo?.status) {
          case 400:
          case 403:
          case 429:
          case 500:
            setTimeout(() => {
              setState('failed');
            }, 2000);
            break;
          case 200:
          case 201:
            setTimeout(() => {
              setState('success');
            }, 2000);
            break;
          default:
            setTimeout(() => {
              setState('failed');
            }, 2000);
        }
      }
    }

    // eslint-disable-next-line
  }, [checkoutInfo]);

  return (
    <div className='d-flex flex-column flex-grow-1 w-100'>
      {state === 'waiting' && (
        <div className='d-flex flex-column justify-content-between flex-grow-1 w-100'>
          <div className='checkout-layout__content d-flex flex-column w-100 h-100 justify-content-center'>
            <Paragraph className='text-header bold brand h2 text-center mb-4'>
              {
                intl.messages[
                  `waiting_status${isReferencePayment ? '_mb_reference' : ''}${isFreePlan ? '_free_plan' : ''}`
                ]
              }
            </Paragraph>
            <div className='ix-loading-checkout mx-auto my-5'>
              <div className='ix-loading-checkout__container'>
                <IxLoading />
              </div>
            </div>
          </div>
        </div>
      )}
      {state === 'success' && (
        <div className='d-flex flex-column justify-content-between flex-grow-1 w-100'>
          <div className='checkout-layout__content d-flex flex-column w-100 h-100 justify-content-center'>
            <Paragraph className='text-header bold brand h2 text-center mb-4'>
              {intl.messages[`success_status${isFreePlan ? '_free_plan' : ''}`]}
            </Paragraph>
            <div className='checkout-success-image-wrapper mx-auto my-5'>
              <Image
                src={
                  'https://invoicexpress-assets.s3.eu-west-1.amazonaws.com/zen.png'
                }
                alt='success'
                className='checkout-success-image'
              />
            </div>
          </div>
          <div className='buttons-wrapper d-flex flex-column align-items-center justify-content-center mt-auto w-100 mb-4'>
            <Button
              label={intl.messages['closeAction']}
              className='button button-primary'
              onClick={() =>
                (window.location.href = buildPath('accounts/details'))
              }
            />
          </div>
        </div>
      )}
      {state === 'failed' && (
        <div className='d-flex flex-column justify-content-between flex-grow-1 w-100'>
          <div className='checkout-layout__content d-flex flex-column w-100 h-100 justify-content-center'>
            <Paragraph className='text-header bold error h2 text-center mb-4'>
              {intl.messages['failed_status']}
            </Paragraph>
            <div className='checkout-success-image-wrapper mx-auto my-5'>
              <Image
                src={
                  'https://invoicexpress-assets.s3.eu-west-1.amazonaws.com/error_image.png  '
                }
                alt='failed'
                className='checkout-failed-image'
              />
              <div className='checkout-error-exclamation'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='108'
                  height='108'
                  viewBox='0 0 108 108'
                  fill='none'
                >
                  <path
                    d='M108 54C108 64.6802 104.833 75.1205 98.8994 84.0008C92.9658 92.881 84.5321 99.8023 74.6649 103.889C64.7977 107.977 53.9401 109.046 43.4651 106.962C32.9902 104.879 23.3683 99.7358 15.8163 92.1837C8.26422 84.6317 3.12122 75.0098 1.03762 64.5349C-1.04598 54.0599 0.023399 43.2023 4.11053 33.3351C8.19766 23.4679 15.119 15.0342 23.9992 9.10064C32.8795 3.16704 43.3198 1.33275e-07 54 1.33275e-07C61.0915 -0.000498094 68.1137 1.39591 74.6655 4.10949C81.2173 6.82307 87.1704 10.8007 92.1849 15.8151C97.1993 20.8296 101.177 26.7827 103.891 33.3345C106.604 39.8863 108 46.9085 108 54ZM54 64.8683C52.0193 64.8683 50.083 65.4556 48.4361 66.5561C46.7892 67.6565 45.5056 69.2206 44.7476 71.0505C43.9896 72.8805 43.7913 74.8941 44.1777 76.8368C44.5641 78.7795 45.5179 80.5639 46.9185 81.9645C48.3191 83.3651 50.1036 84.3189 52.0462 84.7053C53.9889 85.0918 56.0025 84.8934 57.8325 84.1354C59.6624 83.3774 61.2265 82.0938 62.327 80.4469C63.4274 78.8 64.0148 76.8637 64.0148 74.883C64.0148 72.2269 62.9596 69.6796 61.0815 67.8015C59.2034 65.9234 56.6561 64.8683 54 64.8683ZM44.4898 28.8645L46.1058 58.4763C46.1427 59.1435 46.4337 59.7713 46.9191 60.2306C47.4045 60.6899 48.0474 60.9459 48.7157 60.9458H59.2843C59.9526 60.9459 60.5955 60.6899 61.0809 60.2306C61.5663 59.7713 61.8574 59.1435 61.8942 58.4763L63.5102 28.8645C63.5293 28.5099 63.4759 28.1552 63.3534 27.822C63.2308 27.4888 63.0417 27.184 62.7975 26.9263C62.5532 26.6686 62.259 26.4633 61.9329 26.323C61.6067 26.1828 61.2554 26.1104 60.9003 26.1104H47.0997C46.7446 26.1104 46.3933 26.1828 46.0671 26.323C45.741 26.4633 45.4468 26.6686 45.2026 26.9263C44.9584 27.184 44.7692 27.4888 44.6466 27.822C44.5241 28.1552 44.4707 28.5099 44.4898 28.8645Z'
                    fill='#C11A1A'
                  />
                </svg>
              </div>
            </div>
          </div>
          <div className='buttons-wrapper d-flex flex-column align-items-center justify-content-center mt-auto w-100 mb-4'>
            <Button
              label={intl.messages['closeAction']}
              className='button button-primary'
              onClick={() =>
                (window.location.href = buildPath('accounts/details'))
              }
            />
          </div>
        </div>
      )}
      {state === 'reference' && (
        <div className='d-flex flex-column flex-grow-1 w-100 mt-4'>
          <MbReferenceModal
            paymentReference={paymentReference}
          ></MbReferenceModal>
          <div className='buttons-wrapper d-flex flex-column align-items-center m-auto w-100'>
            <Button
              label={intl.messages['closeAction']}
              className='button button-primary my-4'
              onClick={() =>
                (window.location.href = buildPath('accounts/details'))
              }
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default injectIntl(CheckoutPagePaymentResponse);
